import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { USE_GET_SURVEYS_QUERY_KEY } from './get-surveys'

interface DeleteSurveyRequest {
  surveyId: number
}

export const deleteSurvey = async ({ surveyId }: DeleteSurveyRequest) => {
  const response = await authAPI.delete(`/survey/${surveyId}`)
  return response.data
}

export const useDeleteSurvey = () => {
  return useMutation({
    mutationFn: deleteSurvey,
    onSuccess: () => {
      resetQueries([USE_GET_SURVEYS_QUERY_KEY])
    },
  })
}
